import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';
import ConfirmationModal from './ConfirmationModal';

function FoodDetailModal({ isOpen, onClose, food, onEdit, onDelete }) {
  const { t } = useTranslation();
  const [confirmModal, setConfirmModal] = useState({
    isOpen: false
  });
  if (!food) return null;

  const getStatusEmoji = (status) => {
    switch (status) {
      case 'SAFE': return '✅';
      case 'UNSAFE': return '❌';
      case 'CAUTION': return '⚠️';
      default: return '❓';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'SAFE': return '#28a745';
      case 'UNSAFE': return '#dc3545';
      case 'CAUTION': return '#ffc107';
      default: return '#6c757d';
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={`🍽️ ${food.name}`}>
      <div className="food-detail">
        <div className="detail-section">
          <div className="detail-badge" style={{ backgroundColor: getStatusColor(food.safetyStatus) + '20', borderColor: getStatusColor(food.safetyStatus) }}>
            <span className="detail-badge-icon">{getStatusEmoji(food.safetyStatus)}</span>
            <span className="detail-badge-text">{food.safetyStatus}</span>
          </div>
        </div>

        <div className="detail-section">
          <h3>🌍 {t('food.detail.culture')}</h3>
          <p className="detail-value">{food.culture}</p>
        </div>

        {food.reason && (
          <div className="detail-section">
            <h3>📝 {t('food.detail.reason')}</h3>
            <p className="detail-value">{food.reason}</p>
          </div>
        )}

        {food.alternative && (
          <div className="detail-section">
            <h3>🔄 {t('food.detail.alternative')}</h3>
            <p className="detail-value highlight">{food.alternative}</p>
          </div>
        )}

        {food.notes && (
          <div className="detail-section">
            <h3>📋 {t('food.detail.additionalNotes')}</h3>
            <p className="detail-value">{food.notes}</p>
          </div>
        )}

        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>
            {t('food.detail.close')}
          </button>
          <button className="btn-edit-modal" onClick={() => onEdit(food)}>
            ✏️ {t('food.detail.edit')}
          </button>
          <button className="btn-delete-modal" onClick={() => {
            setConfirmModal({ isOpen: true });
          }}>
            🗑️ {t('food.detail.delete')}
          </button>
        </div>
      </div>

      <ConfirmationModal
        isOpen={confirmModal.isOpen}
        onClose={() => setConfirmModal({ isOpen: false })}
        onConfirm={() => {
          onDelete(food.id);
          onClose();
          setConfirmModal({ isOpen: false });
        }}
        title={t('food.detail.deleteTitle')}
        message={t('food.detail.deleteMessage', { name: food.name })}
        type="warning"
        confirmText={t('common.delete')}
        cancelText={t('common.cancel')}
      />
    </Modal>
  );
}

export default FoodDetailModal;
















